export default "__VITE_ASSET__CbpzznWg__"